import './styles/App.css';
import Navbar from './components/navbar';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';

// pages
import Home from './Pages/Home';
import TutorialArchive from './Pages/TutorialArchive';
import DevTeam from './Pages/DevTeam';
import GameProgress from './Pages/GameProgress';
import WorkWithUs from './Pages/WorkWithUs';
import AboutPoly from './Pages/AboutPoly';
import NotFound from './Pages/404';

// theme tutorial routings
import ThemeTutorial from './Pages/Tutorial Archive/Theme Tutorial/ThemeTutorial';
import ThemeMenuConfig from './Pages/Tutorial Archive/Theme Tutorial/ThemeMenuConfig';
import ThemeGameConfig from './Pages/Tutorial Archive/Theme Tutorial/ThemeGameConfig';
import ConfigurableSprites from './Pages/Tutorial Archive/Theme Tutorial/ConfigurableSprites';
import ConfigurableAudioClips from './Pages/Tutorial Archive/Theme Tutorial/ConfigurableAudioClips';
import UploadingYourTheme from './Pages/Tutorial Archive/Theme Tutorial/UploadingYourTheme';
import Footer from "./components/Footer";

const img = {
    _5thStepLightLogo: require("./Assets/Images/5th Step - Light Logo.png")
};
// scroll to top component
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

const App = () => {
    const [loaded, setLoaded] = useState(false);
    const { pathname } = useLocation(); // tracks current route

    useEffect(() => {
        setLoaded(false); // hide content
        const timer = setTimeout(() => setLoaded(true), 100); // delay fade-in
        return () => clearTimeout(timer); // clean up timeout
    }, [pathname]); // triggers on route change

    useEffect(() => {
        const images = document.querySelectorAll('img');
        images.forEach(img => {
            img.setAttribute('loading', 'lazy');
        });
    }, []);

    return (
        <>
            <ScrollToTop /> {/* ensure scroll resets on route change */}

            {/* browser view */}
            <BrowserView>
                <div className={`app-container ${loaded ? 'fade-in' : 'hidden'}`}> {/* hide content until fade-in */}
                    <Navbar /> {/* your navbar with the links */}
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/defaultsite" element={<Home />} />
                        <Route path="/Tutorial-Archive" element={<TutorialArchive />} />
                        <Route path="/Dev-Team" element={<DevTeam />} />
                        <Route path="/Game-Progress" element={<GameProgress />} />
                        <Route path="/Work-With-Us" element={<WorkWithUs />} />
                        <Route path="/About-Poly" element={<AboutPoly />} />
                        <Route path="*" element={<NotFound />} />

                        {/* theme tutorial routings */}
                        <Route path="/Tutorial-Archive/Themes" element={<ThemeTutorial />} />
                        <Route path="/Tutorial-Archive/Themes/Menu.polybeatsconfig" element={<ThemeMenuConfig />} />
                        <Route path="/Tutorial-Archive/Themes/Game.polybeatsconfig" element={<ThemeGameConfig />} />
                        <Route path="/Tutorial-Archive/Themes/ConfigurableSprites" element={<ConfigurableSprites />} />
                        <Route path="/Tutorial-Archive/Themes/ConfigurableAudioClips" element={<ConfigurableAudioClips />} />
                        <Route path="/Tutorial-Archive/Themes/Uploading-Your-Theme" element={<UploadingYourTheme />} />
                    </Routes>
                    <Footer />
                </div>
            </BrowserView>

            {/* mobile view */}
            <MobileView>
                <div className="mobile-placeholder">
                    <img src={img._5thStepLightLogo} alt="5th Step Logo"/>
                    <h1>OUR WEBSITE ISN'T AVAILABLE FOR MOBILE, YET.</h1>
                    <p>Do visit us on PC/Laptop to get a better experience! Thanks.</p>
                </div>
            </MobileView>
        </>
    );
};

const WrappedApp = () => (
    <Router>
        <App />
    </Router>
);

export default WrappedApp;
